export default __webpack_public_path__ + "static/media/Diabetebigpopup.98e42b4b.svg";